import script from "./ProfileForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileForm.vue?vue&type=style&index=0&id=275c8619&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275c8619"]])

export default __exports__